<template>
  <b-modal
    id="pause-subscription-modal"
    :title="$t('edit-community-modal.subscription.subscription-info.suspend-subscription-action')"
    centered
    no-close-on-backdrop
    hide-footer
    class="modal-dialog"
  >
    <!-- Step 1, confirm cancel -->
    <div>
      <div class="text-center">
        <div class="my-1">
          <feather-icon
            icon="AlertTriangleIcon"
            class="font-large-2 text-warning"
          />
        </div>
        <h4 class="mb-1">
          {{ $t('edit-community-modal.subscription.subscription-info.suspend-subscription-modal.are-you-sure') }}
        </h4>
        <p class="mb-2">
          {{ $t('edit-community-modal.subscription.subscription-info.suspend-subscription-modal.are-you-sure-description', { nextBillingCycleDate: moment(subscription.nextBillingTime).format('LL') }) }}
        </p>
        <div class="mb-1 d-flex">
          <b-button
            variant="primary"
            class="w-100 mr-1"
            @click="backToSubscriptionInfo"
          >
            {{ $t('actions.back') }}
          </b-button>
          <b-button
            variant="outline-secondary"
            class="w-100 ml-1"
            @click="pauseSubscription"
          >
            {{ $t('edit-community-modal.subscription.subscription-info.suspend-subscription-action') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BButton, BModal } from 'bootstrap-vue'

export default {
  name: 'PauseConfirmation',
  components: {
    BButton,
    BModal,
  },
  props: {
    subscription: {
      type: Object,
      required: true,
    },
  },
  methods: {
    backToSubscriptionInfo() {
      this.$bvModal.hide('pause-subscription-modal')
    },
    pauseSubscription() {
      this.$bvModal.hide('pause-subscription-modal')
      this.$emit('pause-subscription')
    },
  },
}
</script>
